import { useRoutes } from "react-router-dom";

import { protectedRoutes } from "./protected";

export default function AppRoutes() {
  const routes = useRoutes(protectedRoutes);

  return routes;
}
